<template>
  <div class="service-icons">

    <div class="layout layout--fill-container">

      <div class="layout__item desktop--fifth service-area" v-for="(serviceArea,index) in serviceAreas" v-if="serviceRelationship[serviceArea.name]" style="height:25%">
        <div class="text--center">
          <img class="service-icons__icon" :src="serviceArea.imageOff">
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';

  export default {
    name: 'service-icons',

    props: ['serviceRelationship'],

    data: function () {
      return {
        serviceAreas: ServiceRelationshipsService.serviceAreas,
      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .service-icons {

    .layout {
      padding: 3.5rem;

      .service-icons__icon {
        width: 7rem;
        padding-bottom: 2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ServiceIcons.vue?1fcd7e62